import femaleMuscleGain from "@/female/assets/fitness-goal/muscle-gain.webp";
import femaleWeightLoss from "@/female/assets/fitness-goal/weight-loss.webp";
import usePreloadImg from "@/hooks/usePreloadImg";
import muscleGain from "@/male/assets/goals/muscle-gain.webp";
import weightLoss from "@/male/assets/goals/weight-loss.webp";

const getImages = (isFemale?: boolean) => {
    if (isFemale) return [femaleMuscleGain, femaleWeightLoss];
    if (isFemale === false) return [muscleGain, weightLoss];
    return [femaleMuscleGain, femaleWeightLoss, muscleGain, weightLoss];
};

const usePreloadGoalImgs = (isFemale?: boolean) => {
    const imagesToPreload = getImages(isFemale);

    usePreloadImg(imagesToPreload);
};

export default usePreloadGoalImgs;
